import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SouthEastIcon(props: IconProps) {
    return <Icon {...props} iconKey={"south_east"}/>
}
